var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("hr", {
      staticStyle: {
        "flex-basis": "100%",
        height: "0",
        margin: "0",
        border: "0",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "text textarea w-100" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localValue,
            expression: "localValue",
          },
        ],
        ref: "noteField",
        staticClass: "trigger-select form-control",
        attrs: { id: "note", readonly: _vm.readOnly },
        domProps: { value: _vm.localValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.localValue = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "d-none", attrs: { for: "note" } }, [
        _vm._v(_vm._s(_vm.$t("global.words.note"))),
      ]),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "d-none", attrs: { for: "foreColorPicker" } },
        [_vm._v("Color Picker")]
      ),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "d-none", attrs: { for: "backColorPicker" } },
        [_vm._v("Color Picker")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }